import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import sr from '@utils/sr';
import { srConfig } from '@config';
import Img from 'gatsby-image';
import styled from 'styled-components';
import { theme, mixins, media, Section, Heading } from '@styles';
const { colors, fontSizes, fonts } = theme;

const StyledContainer = styled(Section)`
  position: relative;
  max-width: 900px;
  ${media.thone`
    max-width: 350px;
    margin-bottom:0px;
    padding-bottom: 0px;
  `};
`;
const StyledTabs = styled.div`
  display: flex;
  align-items: flex-start;
  position: relative;
  ${media.thone`
    display: block;
  `};
`;
const StyledTabList = styled.ul`
  display: block;
  position: relative;
  width: max-content;
  z-index: 3;
  padding: 0;
  margin: 0;
  list-style: none;

  ${media.thone`
    display: flex;
    overflow-x: scroll;
    margin-bottom: 30px;
    width: calc(100% + 100px);
    margin-left: -50px;
  `};
  ${media.phablet`
    width: calc(100% + 50px);
    margin-left: -25px;
  `};

  li {
    &:first-of-type {
      ${media.thone`
        margin-left: 50px;
      `};
      ${media.phablet`
        margin-left: 25px;
      `};
    }
    &:last-of-type {
      ${media.thone`
        padding-right: 50px;
      `};
      ${media.phablet`
        padding-right: 25px;
      `};
    }
  }
`;
const StyledTabButton = styled.button`
  ${mixins.link};
  display: flex;
  align-items: center;
  width: 100%;
  background-color: transparent;
  height: ${theme.tabHeight}px;
  padding: 0 20px 2px;
  transition: ${theme.transition};
  border-left: 2px solid ${colors.lightestNavy};
  text-align: left;
  white-space: nowrap;
  font-family: ${fonts.SFMono};
  font-size: ${fontSizes.smish};
  color: ${props => (props.isActive ? colors.green : colors.slate)};
  ${media.tablet`padding: 0 15px 2px;`};
  ${media.thone`
    ${mixins.flexCenter};
    padding: 0 15px;
    text-align: center;
    border-left: 0;
    border-bottom: 2px solid ${colors.lightestNavy};
    min-width: 120px;
  `};
  &:hover,
  &:focus {
    background-color: ${colors.lightNavy};
  }
`;
const StyledHighlight = styled.span`
  display: block;
  background: ${colors.green};
  width: 2px;
  height: ${theme.tabHeight}px;
  border-radius: ${theme.borderRadius};
  position: absolute;
  top: 0;
  left: 0;
  transition: transform 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition-delay: 0.1s;
  z-index: 10;
  transform: translateY(
    ${props => (props.activeTabId > 0 ? props.activeTabId * theme.tabHeight : 0)}px
  );
  ${media.thone`
    width: 100%;
    max-width: ${theme.tabWidth}px;
    height: 2px;
    top: auto;
    bottom: 0;
    transform: translateX(
      ${props => (props.activeTabId > 0 ? props.activeTabId * theme.tabWidth : 0)}px
    );
    margin-left: 50px;
  `};
  ${media.phablet`
    margin-left: 25px;
  `};
`;
const StyledTabContent = styled.div`
  position: relative;
  width: 100%;
  height: auto;
  padding-top: 12px;
  padding-left: 30px;
  ${media.tablet`padding-left: 20px;`};
  ${media.thone`padding-left: 0;`};

  ul {
    ${mixins.fancyList};
  }
  a {
    ${mixins.inlineLink};
  }
`;
const StyledPublicationTitle = styled.h4`
  color: ${colors.lightestSlate};
  font-size: ${fontSizes.xxl};
  font-weight: 500;
  margin-bottom: 5px;
`;
const StyledCompany = styled.span`
  color: ${colors.green};
`;
const StyledPublicationDetails = styled.h5`
  font-family: ${fonts.SFMono};
  font-size: ${fontSizes.smish};
  font-weight: normal;
  letter-spacing: 0.05em;
  color: ${colors.lightSlate};
  margin-bottom: 30px;
  svg {
    width: 15px;
  }
`;

const StyledGallery = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 50px;
  ${media.thone`
    display: none;
  `};
`;

const StyledCarousel = styled.div`
  display: none;
  ${media.thone`
    display: flex;
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
    width: 100%;
    margin-top: 20px;
    // margin-left: 20px;
    padding-left:25px;
    padding-top:10px;
  `};
`;

const StyledCarouselItem = styled.div`
  flex: none;
  width: 80%;
  scroll-snap-align: center;
  position: relative;
  ${media.thone`
    width: 100%;
  `};
`;

const StyledModal = styled.div`
  display: ${props => (props.isOpen ? 'flex' : 'none')};
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const StyledModalImage = styled.img`
  width: auto;
  height: auto;
  max-width: 90%;
  max-height: 90%;
  border-radius: 8px;
  @media (max-width: 768px) {
    max-width: 100%;
    max-height: 80%;
  }
`;


const StyledArrow = styled.div`
  position: absolute;
  top: 50%;
  ${props => (props.direction === 'left' ? 'left: 10px;' : 'right: 10px;')}
  font-size: 2rem;
  color: white;
  cursor: pointer;
  user-select: none;
`;
const StyledPic = styled.div`
  position: relative;
  width: 40%;
  max-width: 300px;
  margin-left: 5px;
  ${media.tablet`margin: 60px auto 0;`};
  ${media.phablet`width: 70%;`};
  a {
    &:focus {
      outline: 0;
    }
  }
`;
const StyledAvatar = styled(Img)`
  position: relative;
  mix-blend-mode: multiply;
  filter: grayscale(100%) contrast(1);
  border-radius: ${theme.borderRadius};
  transition: ${theme.transition};
`;
const StyledAvatarLink = styled.a`
  ${mixins.boxShadow};
  width: 100%;
  position: relative;
  border-radius: ${theme.borderRadius};
  background-color: ${colors.lightestSlate};
  margin-left: -20px;
  &:hover,
  &:focus {
    background: transparent;
    &:after {
      top: 15px;
      left: 15px;
    }
    ${StyledAvatar} {
      filter: none;
      mix-blend-mode: normal;
    }
  }
  &:before,
  &:after {
    content: '';
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: ${theme.borderRadius};
    transition: ${theme.transition};
  }
  &:before {
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${colors.navy};
    mix-blend-mode: screen;
  }
  &:after {
    border: 2px solid ${colors.green};
    top: 10px;
    left: 10px;
    z-index: -1;
  }
`;

const StyledMainContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  overflow-x: hidden;
  ${media.thone`
    display: relative !important;
    flex-direction: column;
    overflow-x: visible;
    max-width: 700px !important;
    
  `};
`;

const StyledGalleryContainer = styled(Section)`
  position: relative;
  max-width: 500px;
  margin-left: 100px;
  width: 700px;
  ${media.thone`
    max-width: 100%;
    margin-left: 0;
    margin-top: 0px;
    margin: 0 0;
    padding-top: 0px;
  `};
`;

const Publications = ({ data }) => {
  const [activeTabId, setActiveTabId] = useState(0);
  const [tabFocus, setTabFocus] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const tabs = useRef([]);

  const revealContainer = useRef(null);
  useEffect(() => sr.reveal(revealContainer.current, srConfig()), []);

  const focusTab = () => {
    if (tabs.current[tabFocus]) {
      tabs.current[tabFocus].focus();
    } else {
      // If we're at the end, go to the start
      if (tabFocus >= tabs.current.length) {
        setTabFocus(0);
      }
      // If we're at the start, move to the end
      if (tabFocus < 0) {
        setTabFocus(tabs.current.length - 1);
      }
    }
  };

  // Only re-run the effect if tabFocus changes
  useEffect(() => focusTab(), [tabFocus]);

  const onKeyPressed = e => {
    if (e.keyCode === 38 || e.keyCode === 40) {
      e.preventDefault();
      if (e.keyCode === 40) {
        // Move down
        setTabFocus(tabFocus + 1);
      } else if (e.keyCode === 38) {
        // Move up
        setTabFocus(tabFocus - 1);
      }
    }
  };

  const openModal = (image, index) => {
    setSelectedImage(image);
    setCurrentImageIndex(index);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  const showPrevImage = () => {
    setCurrentImageIndex((currentImageIndex - 1 + selectedImage.length) % selectedImage.length);
  };

  const showNextImage = () => {
    setCurrentImageIndex((currentImageIndex + 1) % selectedImage.length);
  };

  return (
    <StyledMainContent>
      <StyledContainer id="publications" ref={revealContainer}>
        <Heading>Research & Publications</Heading>
        <StyledTabs>
          <StyledTabList role="tablist" aria-label="Publication tabs" onKeyDown={e => onKeyPressed(e)}>
            {data &&
              data.map(({ node }, i) => {
                const { company } = node.frontmatter;
                return (
                  <li key={i}>
                    <StyledTabButton
                      isActive={activeTabId === i}
                      onClick={() => setActiveTabId(i)}
                      ref={el => (tabs.current[i] = el)}
                      id={`tab-${i}`}
                      role="tab"
                      aria-selected={activeTabId === i ? true : false}
                      aria-controls={`panel-${i}`}
                      tabIndex={activeTabId === i ? '0' : '-1'}>
                      <span>{company}</span>
                    </StyledTabButton>
                  </li>
                );
              })}
            <StyledHighlight activeTabId={activeTabId} />
          </StyledTabList>

          {data &&
            data.map(({ node }, i) => {
              const { frontmatter, html } = node;
              const { title, url, company, range } = frontmatter;
              return (
                <StyledTabContent
                  key={i}
                  isActive={activeTabId === i}
                  id={`panel-${i}`}
                  role="tabpanel"
                  aria-labelledby={`tab-${i}`}
                  tabIndex={activeTabId === i ? '0' : '-1'}
                  hidden={activeTabId !== i}>
                  <StyledPublicationTitle>
                    <span>{title}</span>
                    <StyledCompany>
                      <span>&nbsp;@&nbsp;</span>
                      <a href={url} target="_blank" rel="nofollow noopener noreferrer">
                        {company}
                      </a>
                    </StyledCompany>
                  </StyledPublicationTitle>
                  <StyledPublicationDetails>
                    <span>{range}</span>
                  </StyledPublicationDetails>
                  <div dangerouslySetInnerHTML={{ __html: html }} />
                </StyledTabContent>
              );
            })}
        </StyledTabs>
      </StyledContainer>

      <StyledGalleryContainer>
        {/* <Heading>Gallery</Heading> */}
        <StyledGallery>
          {data[activeTabId] &&
            data[activeTabId].node.frontmatter.images.map((image, index) => (
              <StyledPic
                key={index}
                onClick={() => openModal(data[activeTabId].node.frontmatter.images, index)}>
                <StyledAvatarLink
                  onClick={() => openModal(data[activeTabId].node.frontmatter.images, index)}>
                  <StyledAvatar
                    src={image.childImageSharp.fluid.src}
                    alt={`Publication image ${index + 1}`}
                    fluid={image.childImageSharp.fluid}
                  />
                </StyledAvatarLink>
              </StyledPic>
            ))}
        </StyledGallery>

        <StyledCarousel>
          {data[activeTabId] &&
            data[activeTabId].node.frontmatter.images.map((image, index) => (
              <StyledCarouselItem
                key={index}
                onClick={() => openModal(data[activeTabId].node.frontmatter.images, index)}>
                <StyledAvatarLink
                  onClick={() => openModal(data[activeTabId].node.frontmatter.images, index)}>
                  <StyledAvatar
                    src={image.childImageSharp.fluid.src}
                    alt={`Publication image ${index + 1}`}
                    fluid={image.childImageSharp.fluid}
                  />
                </StyledAvatarLink>
              </StyledCarouselItem>
            ))}
        </StyledCarousel>
      </StyledGalleryContainer>

      {selectedImage && (
        <StyledModal isOpen={!!selectedImage} onClick={closeModal}>
          <StyledArrow
            direction="left"
            onClick={e => {
              e.stopPropagation();
              showPrevImage();
            }}>
            &#9664;
          </StyledArrow>
          <StyledModalImage
            src={selectedImage[currentImageIndex].childImageSharp.fluid.src}
            alt={`Selected publication image ${currentImageIndex + 1}`}
          />
          <StyledArrow
            direction="right"
            onClick={e => {
              e.stopPropagation();
              showNextImage();
            }}>
            &#9654;
          </StyledArrow>
        </StyledModal>
      )}
    </StyledMainContent>
  );
};

Publications.propTypes = {
  data: PropTypes.array.isRequired,
};

export default Publications;
